module.exports = __webpack_public_path__ + "img/9_ward_5.051ca935.png";